export default class LessonVideoInfo {
  public start_time?: number | string = undefined;
  public end_time?: number | string = undefined;

  public assign(response: any): LessonVideoInfo {
    if (response) {
      for (const key in response) {
        if (response.hasOwnProperty(key) && this.hasOwnProperty(key)) {
          (this as any)[key] = response[key];
        }
      }
    }

    return this;
  }
}
